import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditInfo = () => {
  const currentDate = new Date()?.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  const mockIP = '192.168.1.100';

  return (
    <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 text-xs text-muted-foreground">
      <div className="flex items-center gap-2">
        <Icon name="Clock" size={14} />
        <span>{currentDate}</span>
      </div>
      <div className="hidden md:block w-1 h-1 bg-muted-foreground rounded-full" />
      <div className="flex items-center gap-2">
        <Icon name="Globe" size={14} />
        <span>IP: {mockIP}</span>
      </div>
      <div className="hidden md:block w-1 h-1 bg-muted-foreground rounded-full" />
      <div className="flex items-center gap-2">
        <Icon name="FileText" size={14} />
        <span>All access logged for HIPAA compliance</span>
      </div>
    </div>
  );
};

export default AuditInfo;